var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "cd-container cd-box-component" },
    [
      _c(
        "b-row",
        _vm._l(_vm.models, function(model) {
          return _c(
            "b-col",
            {
              key: model.id,
              staticClass: "cd-entry cd-model p-2",
              attrs: { cols: "6", xs: "6", sm: "6", md: "6", lg: "3", xl: "3" },
              on: {
                click: function($event) {
                  return _vm.selectModel(model)
                }
              }
            },
            [
              _c(
                "Box",
                {
                  staticClass: "cd-primary-sub-color",
                  attrs: { image: _vm.imageUriForModel(model) }
                },
                [
                  _c("p", { staticClass: "cd-model-label" }, [
                    _vm._v(_vm._s(model.label))
                  ]),
                  _c("span", { staticClass: "cd-original-price" }, [
                    _vm._v(
                      "uvp ab " +
                        _vm._s(
                          _vm._f("formatCurrency")(model.min_price_gross)
                        ) +
                        " €"
                    )
                  ]),
                  _c("span", { staticClass: "cd-new-price" }, [
                    _vm._v(
                      "ab " +
                        _vm._s(
                          _vm._f("formatCurrency")(
                            _vm.getNewPrice(
                              model["min_price_" + _vm.pricing],
                              model
                            )
                          )
                        ) +
                        " €"
                    )
                  ]),
                  _vm.shouldDisplayRate(model) && _vm.getRate(model) != null
                    ? _c("div", { staticClass: "cd-new-price" }, [
                        _vm._v(
                          _vm._s(_vm._f("formatCurrency")(_vm.getRate(model))) +
                            " € / Monat"
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-hover",
                      attrs: { type: "button" }
                    },
                    [_vm._v("jetzt konfigurieren")]
                  )
                ]
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }